import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { About } from '@/features/content/About';
import { MobileAbout } from '@/features/content/mobile/MobileAbout';

export const Route = createFileRoute('/_app/about')({ component: AboutRoute });

/** Selettore: Chi siamo mobile (MaeDesign) vs pagina desktop. */
function AboutRoute() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileAbout /> : <About />;
}
